import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_dashboard_index_data = createAsyncThunk(
    'dashboard/get_dashboard_index_data',
    async (userId, {
        rejectWithValue,
        fulfillWithValue,
        getState
    }) => {
        if (!userId) {
            return rejectWithValue({ error: 'Missing customer id' })
        }

        try {
            const {
                data
            } = await api.get(`/home/customer/gat-dashboard-data/${userId}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Dashboard data could not be loaded' })
        }
    }
)

const defaultDashboard = {
    totalOrder: 0,
    pendingOrder: 0,
    cancelledOrder: 0,
    wishlistCount: 0,
    recentOrders: []
}

export const dashboardReducer = createSlice({
    name: 'dashboard',
    initialState: {
        recentOrders: [],
        errorMessage: '',
        successMessage: '',
        totalOrder: 0,
        pendingOrder: 0,
        cancelledOrder: 0,
        wishlistCount: 0
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
extraReducers: (builder) => {
    builder.addCase(get_dashboard_index_data.fulfilled, (state, { payload }) => {
        const data = payload || defaultDashboard;
        state.totalOrder = data.totalOrder || 0;
        state.pendingOrder = data.pendingOrder || 0;
        state.cancelledOrder = data.cancelledOrder || 0;
        state.wishlistCount = data.wishlistCount || 0;
        state.recentOrders = Array.isArray(data.recentOrders) ? data.recentOrders : [];
    })
    .addCase(get_dashboard_index_data.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error || '';
        state.totalOrder = state.totalOrder || 0;
        state.pendingOrder = state.pendingOrder || 0;
        state.cancelledOrder = state.cancelledOrder || 0;
        state.wishlistCount = state.wishlistCount || 0;
        state.recentOrders = Array.isArray(state.recentOrders) ? state.recentOrders : [];
    });
}
})

export const {
    messageClear
} = dashboardReducer.actions
export default dashboardReducer.reducer
